/**
 * @generated SignedSource<<ec6c3f5418cf0d26e625e71fbae2dd52>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WorkspaceSignalLinkProductMutation$variables = {
  productId: string;
  signalWorkspaceId: string;
};
export type WorkspaceSignalLinkProductMutation$data = {
  readonly signalWorkspace: {
    readonly linkProduct: {
      readonly id: string;
    };
  };
};
export type WorkspaceSignalLinkProductMutation = {
  response: WorkspaceSignalLinkProductMutation$data;
  variables: WorkspaceSignalLinkProductMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "signalWorkspaceId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "signalWorkspaceId"
      }
    ],
    "concreteType": "SignalWorkspaceMutation",
    "kind": "LinkedField",
    "name": "signalWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "productId",
            "variableName": "productId"
          }
        ],
        "concreteType": "SignalWorkspace",
        "kind": "LinkedField",
        "name": "linkProduct",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalLinkProductMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalLinkProductMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3c64a79d1be38cb56760de1a2bf01a19",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalLinkProductMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalLinkProductMutation(\n  $productId: ID!\n  $signalWorkspaceId: ID!\n) {\n  signalWorkspace(id: $signalWorkspaceId) {\n    linkProduct(productId: $productId) {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0fd31fe27b409ee7190ab804f5f53dd7";

export default node;
